module.exports = {
  PACKAGE: 'package',
  MEMBERSHIP: 'membership'
}
